import { useMemo } from 'react';

import PageHeader from 'components/global/PageHeader';
import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { REPORT } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

/**
 * @author @muhammedburakak
 */

const ExportLogList = () => {
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);

	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'ID', width: 60, filterType: FilterType.number, show: false },
			{
				Header: 'name',
				accessor: 'name',
				width: 100,
				filterType: FilterType.multiSelection,
				renderCell: ListComponents.EXPORT_FILE_NAME,
				showOnMobile: true
			},

			{
				Header: 'fileFormat',
				accessor: 'fileFormat',
				width: 50,
				filterType: FilterType.multiSelection,
				show: false
			},
			{
				Header: 'records',
				accessor: 'records',
				width: 50,
				filterType: FilterType.number
			},
			{
				Header: 'requestDate',
				accessor: 'requestDate',
				width: 110,
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'status',
				accessor: 'status',
				width: 80,
				filterType: FilterType.multiSelection,
				renderCell: ListComponents.EXPORT_FILE_STATUS,
				showOnMobile: true
			}
		],
		[]
	);

	return (
		<TabTableContainer>
			<PageHeader
				lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/Export-New.json.gz"
				title="exports"
			/>
			<DynamicList
				id={DYNAMICLISTS.EXPORT_LOGS}
				defaultSort={defaultSort}
				columns={columns}
				fetchUrl={REPORT.LIST.GET_EXPORT_LOG_LIST}
				exportName="exportData"
			/>
		</TabTableContainer>
	);
};

export default ExportLogList;
